import { render, staticRenderFns } from "./DevelopChange.vue?vue&type=template&id=203fa030&scoped=true&"
import script from "./DevelopChange.vue?vue&type=script&lang=js&"
export * from "./DevelopChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203fa030",
  null
  
)

export default component.exports